import React from 'react';
import { FaIndustry, FaGlobeAmericas, FaShieldAlt } from 'react-icons/fa';

const Features = () => {
  const featuresList = [
    {
      icon: <FaShieldAlt size={32} />,
      title: "جودة عالية",
      description: "تخضع جميع أدواتنا ومعداتنا لاختبارات صارمة لضمان تلبية أعلى معايير السلامة والأداء العالمية."
    },
    {
      icon: <FaGlobeAmericas size={32} />,
      title: "تنوع شامل",
      description: "نوفر مجموعة واسعة من العدد الكهربائية وأدوات التجارة والنجارة لتلبية كافة احتياجات المقاولات."
    },
    {
      icon: <FaIndustry size={32} />,
      title: "هندسة متقدمة",
      description: "معدات مصممة بأحدث التقنيات الهندسية لزيادة كفاءة العمل وتقليل وقت التوقف عن العمل."
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="features-header animate-fade-in-up">
        <h2 className="section-title">لماذا نحن الأفضل؟</h2>
        <p className="section-subtitle">الخيار الأول للشركات الهندسية ورواد المقاولات</p>
      </div>
      
      <div className="features-grid">
        {featuresList.map((feature, index) => (
          <div 
            key={index} 
            className={`feature-card animate-fade-in-up delay-${(index + 1) * 100}`}
          >
            <div className="feature-icon-wrapper">
              {feature.icon}
            </div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
